export default __webpack_public_path__ + "static/media/optimized-payments.46fd5efb.svg";